import React from 'react'

import { components } from 'react-select'

export const MultiValue: typeof components.MultiValue = ({
  innerProps,
  ...props
}) => {
  const { children } = props
  const newInnerProps: typeof innerProps = {
    ...innerProps,
    title: children as string,
  }

  return <components.MultiValue {...props} innerProps={newInnerProps} />
}
